module.exports = __webpack_public_path__ + "e77a1418.svg";